import Header from "components/common/header"

function Studio (){

    return (
        <div className="wrapper">
           <Header />
           <main>
                <h1>
                    This is Studio Page
                </h1>
           </main>
        </div>
    )
}

export default Studio